import React from 'react'
import './LHSNavigation.css'
import { readCookie, checkUserLogin, getCookie } from 'AccountsUtils'
import { getMappedValue } from '../../../utils/arabicUtils'

const getLocaleBasedUrl = (path) => {
  const langCode = getCookie('selectedLanguage') === 'ar' ? 'ar' : 'en'
  return `/${langCode}${path}`
}

const LHSNavigation = props => {
  const isLogin = checkUserLogin()
  const ctAuthNoLogin = readCookie('ct-auth-no-login')
  const isOtpFlow = ctAuthNoLogin && !isLogin
  const selectedClass = isOtpFlow ? '' : 'selected'
  const { section } = props

  const isSelected = (id) => {
    if (id === 'trips_tab') {
      return section !== 'wallet_tab' && section !== 'profile_tab' && section !== 'travellers_tab'
    }
    return section === id
  }

  const navigationOptions = [
    {
      liClass: `tripsTab ${isSelected('trips_tab') ? selectedClass : ''}`,
      link: getLocaleBasedUrl('/trips'),
      linkClass: 'app-link icon navLink navTrips',
      id: 'trips_tab',
      title: 'Your travel bookings',
      text: 'My Bookings'
    },
    {
      liClass: `walletTab ${isSelected('wallet_tab') ? selectedClass : ''}`,
      link: getLocaleBasedUrl('/wallet'),
      linkClass: 'app-link icon navLink navWallet',
      id: 'wallet_tab',
      title: 'Your Wallet',
      text: 'Wallet'
    },
    {
      liClass: `profileTab ${isSelected('profile_tab') ? selectedClass : ''}`,
      link: getLocaleBasedUrl('/profile'),
      linkClass: 'app-link icon navLink navMe',
      id: 'profile_tab',
      title: 'Your profile & preferences',
      text: 'Profile'
    },
    {
      liClass: `travellersTab ${isSelected('travellers_tab') ? selectedClass : ''}`,
      link: getLocaleBasedUrl('/travellers'),
      linkClass: 'app-link icon navLink navTravellers',
      id: 'travellers_tab',
      title: 'People you book travel for',
      text: 'Travellers'
    }
  ]

  return (
    <ul className="navLeft">
      {navigationOptions.map((option, index) => {
        const { liClass, link, linkClass, id, title, text } = option
        const lockClass = isOtpFlow ? 'navLinkLock' : ''
        return (
          <li key={id + index} className={`${liClass} navTab`}>
            <a
              href={link}
              onClick={e => {
                if (isOtpFlow) {
                  e.preventDefault()
                }
              }}
              className={`${linkClass} ${lockClass} cursorPoi us-text`}
              id={id}
              title={title}
            >
              {getMappedValue(text)}
            </a>
          </li>
        )
      })}
    </ul>
  )
}

export default LHSNavigation
